export const blockIconsHouseholdShowerNew = (
	<span className='material-symbols-outlined'>shower</span>
);
